/**
 * Family Site Menu Component
 */
export class FamilySiteMenu {
    constructor() {
        this.familyBtn = document.getElementById('family-site-btn');
        this.familyMenu = document.getElementById('family-site-menu');
        this.familyClose = document.getElementById('family-site-close');
        
        if (!this.familyBtn || !this.familyMenu || !this.familyClose) return;
        
        this.init();
    }

    init() {
        this.familyBtn.addEventListener('click', () => this.openMenu());
        this.familyClose.addEventListener('click', () => this.closeMenu());
        
        // Close on ESC key
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.familyMenu.classList.contains('is-open')) {
                this.closeMenu();
            }
        });
        
        // Close on backdrop click
        this.familyMenu.addEventListener('click', (e) => {
            if (e.target === this.familyMenu) {
                this.closeMenu();
            }
        });
    }

    openMenu() {
        this.familyMenu.classList.add('is-open');
        this.familyBtn.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
    }

    closeMenu() {
        this.familyMenu.classList.remove('is-open');
        this.familyBtn.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
    }
}

